import { BAlert } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBAlert when migrating. */
export const EgBAlert = createEgBootstrapProxy("EgBAlert", BAlert);
